import styled from 'styled-components'
import { Button } from 'antd'
export const CallButton = styled(Button)`
  width: 250px;
  height: 250px;
  font-size: 125px;
  line-height: 1;
  border-width: 15px;
`
